export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9557.fea519ca.jpg";